import axios from "axios";
import store from "../../store";

let moment = require("moment");

class GraphsService {
  async fetchAllDateSlideListeners(start, end) {
    await this.fetchDataPerDay(start, end);
  }

  async fetchDataPerDay(start, end) {
    const result = await axios.post(
      `${process.env.REACT_APP_BASE_URL_API}/monitoring/per-day`,
      {
        from: start,
        to: end,
        domains: [-1],
      }
    );

    store.setEvents(result.data.events);
    store.setCheckouts(result.data.checkouts);
    store.setRps(result.data.rps);
    store.setWinsControlAndTwikDealsGraphData(
      result.data.wins_count_control_and_twik
    );
    store.setWinsOnlyTwikDealsGraphData(result.data.wins_count_twik);
    store.setIncreasedRevenueGraphData(result.data.increased_revenue);
    store.setRevenueSegmentsGraphData(result.data.revenue_segments);
    store.setFpOverlapsGraphData(result.data.fp_overlaps);
    store.setFpSurvivability(result.data.fp_survivability);
    store.setAllTimeRevenueSegmentsGraphData(result.data.all_time_revenue);
    store.setWinsControlAndTwikNoCacheDealsGraphData(result.data.wins_count_control_and_twik_no_cache);
    store.setWinsTwikNoCacheDealsGraphData(result.data.wins_count_twik_no_cache);
  }

  async fetchEntityGraphData(
    entity,
    app_type,
    start,
    end,
    group_by,
    graph_type
  ) {
    const result = await axios.post(
      `${process.env.REACT_APP_BASE_URL_API}/monitoring/kpi/${entity}`,
      {
        from: start,
        to: end,
        app_type: app_type,
        group_by: group_by,
        graph_type: graph_type,
        domains: [-1],
      }
    );

    return result.data;
  }

  async fetchFullSegmentsData(entity, app_type, start, end, group_by) {
    const result = await axios.post(
      `${process.env.REACT_APP_BASE_URL_API}/monitoring/kpi-full-segments`,
      {
        from: start,
        to: end,
        kpi: entity,
        app_type: app_type,
        group_by: group_by,
        domains: [-1],
      }
    );

    return result.data;
  }

  async fetchLastMinutesGraphData() {
    const result = await axios.get(
      `${process.env.REACT_APP_BASE_URL_API}/monitoring/last-minutes`
    );

    return result.data.map((obj) => {
      return {
        ...obj,
        full_hour: moment(obj.full_hour, "hh:mm")
          .add("2", "hours")
          .format("HH:mm:ss"),
      };
    });
  }

  async fetchLastMinutesCompareGraphData(date, from, to) {
    const result = await axios.post(
      `${process.env.REACT_APP_BASE_URL_API}/monitoring/last-minutes/compare`,
      {
        date,
        from,
        to,
        domains: [-1],
      }
    );

    return result.data.map((obj) => {
      return {
        ...obj,
        full_hour: moment(obj.full_hour, "hh:mm")
          .add("2", "hours")
          .format("HH:mm:ss"),
      };
    });
  }

  async fetchLastHoursKpiByTimeFrame(kpi, time_frame) {
    const result = await axios.get(
      `${process.env.REACT_APP_BASE_URL_API}/monitoring/last-hours/${kpi}/${time_frame}`
    );

    Object.keys(result.data).map((time_frame) => {
      result.data[time_frame] = result.data[time_frame].map((obj) => {
        return {
          ...obj,
          only_hour: moment(obj.only_hour, "h:m")
            .add("2", "hours")
            .format("HH:mm"),
        };
      });
    });

    return result.data;
  }
}

const graphsService = new GraphsService();

export default graphsService;
